import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import commonConfig from '../common.config'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueI18n from 'vue-i18n';
import utils from './lib/utils';
import Vuex from 'vuex';
import commonStoreConfig from './store/store';
import vuetify from './plugins/vuetify';

import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css' // import the croppie css manually
Vue.use(VueCroppie);

Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.use(Vuex);



Vue.config.productionTip = false;
Vue.prototype.$ajax = axios;
Vue.prototype.$ajax.defaults.withCredentials = (commonConfig.mode === 'local');
Vue.prototype.commonConfig = commonConfig;
Vue.prototype.commonUtils = utils;

const locales = {
    zh: require('./locales/zh/translations.json'),
    en: require('./locales/en/translations.json')
};
const i18n = new VueI18n({
    locale: utils.getDefaultLanguage(),
    messages: locales
});

axios.defaults.withCredentials = commonConfig.mode === 'local';
const loginCheck = axios.get(utils.getRequestUrl('/login_check'));

const store = new Vuex.Store(commonStoreConfig);
new Vue({
    vuetify,
    i18n,
    router,
    render: h => h(App),
    store,

    created() {
        if (window.location.host == "creator.17lianqin.cn") {
            this.$i18n.locale = "zh";
        } else {
            this.$i18n.locale = "en";
        }
    },
    mounted: function () {
        this.$router.replace({
            name: 'home'
        });
        document.title = this.$t('global.text.page_title');
        loginCheck.then((response) => {
            const result = response.data;
            if (result && result.is_login) {
                this.$store.commit('rememberUser', {user: result.user});
                this.$store.commit('toPage', {router_name: 'albums'});
                this.$router.replace({
                    name: 'albums'
                });
                this.commonUtils.initStoreData(this);
            } else {
                console.log('is not login')
                this.$router.push('/login');
            }
        }).catch(err => {
            console.log('login the err', err);
        });

    }
}).$mount('#app');
